import {
  localeFormatter,
  tooltipFormatter,
} from '../../../utils/formatters';

export const userColumns = [
  {
    dataField: 'id',
    text: 'user.id',
    headerClassName: 'created-at',
    disableSort: true,
    formatter: tooltipFormatter,
  },
  {
    dataField: 'username',
    text: 'user.username',
    disableSort: true,
  },
  {
    dataField: 'full_name',
    text: 'user.full_name',
    disableSort: true,
  },
  {
    dataField: 'role',
    text: 'user.role',
    headerClassName: 'user-column',
    disableSort: true,
    formatter: r => localeFormatter('user.role', r),
  },
  {
    dataField: 'tg_id',
    text: 'user.tg_id',
    headerClassName: 'user-column',
    disableSort: true,
  },
  // {
  //   dataField: 'tg_username',
  //   text: 'user.tg_username',
  //   headerClassName: 'user-column',
  //   disableSort: true,
  // },
  {
    dataField: 'is_active',
    text: 'user.is_active',
    headerClassName: 'user-column',
    disableSort: true,
    formatter: r => (r ? 'Активен' : 'Неактивен'),
  },
];

export const userAdditionalColumns = [];
